import { CurrentUser } from '@root/types';
import OnlyInMobile from '@components/shared/OnlyInMobile';
import OnlyInDesktopTablet from '@components/shared/OnlyInDesktopTablet';
import {
  CompanyLogoDisplay,
  EmailDisplay,
  FirstNameDisplay,
  LastNameDisplay,
  TourbookPhoneDisplay,
  YourPhotoDisplay,
} from '@components/layouts/Truva/AccountSettings/utils';
import s from '../AccountSettings.module.less';

type Props = {
  currentUser: CurrentUser;
};

const TourbookInfoContent = ({ currentUser }: Props) => (
  <>
    <div className={s.photosGrid}>
      <YourPhotoDisplay currentUser={currentUser} image={currentUser.tourbookAvatarImage} />
      <CompanyLogoDisplay currentUser={currentUser} image={currentUser.tourbookCompanyImage} />
    </div>
    <OnlyInMobile>
      <div className={s.inputGrid}>
        <TourbookPhoneDisplay currentUser={currentUser} />
        <FirstNameDisplay currentUser={currentUser} />
        <LastNameDisplay currentUser={currentUser} />
        <EmailDisplay currentUser={currentUser} />
      </div>
    </OnlyInMobile>
    <OnlyInDesktopTablet>
      <div className={s.inputGrid}>
        <TourbookPhoneDisplay currentUser={currentUser} />
        <FirstNameDisplay currentUser={currentUser} />
        <LastNameDisplay currentUser={currentUser} />
        <EmailDisplay currentUser={currentUser} />
      </div>
    </OnlyInDesktopTablet>
  </>
);

export default TourbookInfoContent;
